<template>
	<form class="wide" v-else-if="formReady" @submit.prevent="submit">
		<loader v-if="!formReady"/>
		<template v-else>
			<fieldset>
				<div>
					<div>
						<legend><span>Tags</span></legend>
					</div>
					<div>
						<table>
							<thead>
								<tr>
									<th align="left">Tag</th>
									<th align="right" class="actions"><span>Actions</span></th>
								</tr>
							</thead>
							<tfoot>
								<tr>
									<th align="left">Tag</th>
									<th align="right" class="actions"><span>Actions</span></th>
								</tr>
							</tfoot>
							<tr v-for="(tag, tagIndex) in tags" :key="tagIndex">
								<td>
									<tag :tag="tag" htmltag="span"/>
								</td>
								<td align="right">
									<v-contextual>
										<v-contextual-option
											@click="deleteTag(tag)">Delete</v-contextual-option>
									</v-contextual>
								</td>
							</tr>
						</table>
						<div class="input-group">
							<label><span>Tag </span>
								<input type="text" v-model="form.data.name">
							</label>
							<label><span>Color </span>
								<select v-model="form.data.meta.color">
									<option
										v-for="(color, colorIndex) in form.options.colors" :value="colorIndex"
										v-html="$present('ucWords', colorIndex)"/>
								</select>
							</label>
						</div>
					</div>
				</div>
			</fieldset>
			<div class="actions">
				<ul>
					<li>
						<process-button class="button button--primary" :processing="form.processing" text="Add Tag"/>
					</li>
				</ul>
			</div>
		</template>
	</form>
</template>
<script>
import Tag from "../../../../../common/components/Tag";

export default {
	components: {
		Tag,
	},
	data() {
		return {
			formReady: false,
			form: this.newForm({
				name: "",
				meta: {
					color: "",
				}
			}),
			tags: {},
		};
	},

	props: {
		serviceProvider: {
			type: Object,
			default() {
				return this.$authed().service_provider;
			}
		}
	},

	methods: {
		deleteTag(tag) {
			console.log("delete tag", tag);
		},
		async submit() {
			this.form.post(
				this.route("service-providers/:serviceProvider/tags", this.serviceProvider)
			).then(response => {
				this.tags.push(response.data);
				this.form.reset();
			});
		}
	},

	created() {
		this.tags = this.serviceProvider.managedTags;

		http().get(this.route("form-data/tags/:serviceProvider", this.serviceProvider)).then(response => {
			this.form.setOptions(response.data.options);
			this.formReady = true;
		});
	},
};
</script>
